import React from 'react';
import {
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import { Controller } from 'react-hook-form';


function UserForm(props){
  const { isEditableForm } = props;
  const { first_name, last_name, phone, is_active, email, profile_type} = props.data || {};  
  const { register, errors, control } = props.formConfig; 
  
  return (
    <form noValidate autoComplete="off" >
      <Grid container spacing={3} direction="row">
        <Grid item xs={6}>
          <TextField 
            id="filled-basic"
            label="First Name"
            name="first_name"
            placeholder="Usern first name"
            variant="filled"
            disabled={!isEditableForm}
            fullWidth={true}

            defaultValue={first_name}
            inputRef={register({ required: true, minLength: { value: 3, message: "Too short!." } })}
            error={errors.first_name ? true : false}
            helperText={errors.first_name ? errors.first_name.message : null}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField 
            id="filled-basic"
            label="Last Name"
            name="last_name"
            placeholder="Usern last name"
            variant="filled"
            disabled={!isEditableForm}
            fullWidth={true}

            defaultValue={last_name}
            inputRef={register({ required: true, minLength: { value: 3, message: "Too short!." } })}
            error={errors.last_name ? true : false}
            helperText={errors.last_name ? errors.last_name.message : null}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField 
            id="filled-basic"
            label="Phone"
            name="phone"
            placeholder="User phone"
            variant="filled"
            disabled={!isEditableForm}
            fullWidth={true}

            defaultValue={phone}
            inputRef={register({ required: false, minLength: { value: 3, message: "Too short!." } })}
            error={errors.phone ? true : false}
            helperText={errors.phone ? errors.phone.message : null}
          />
        </Grid>
      
        <Grid item xs={6}>
          <TextField 
            name="email"                  
            id="email"
            label="E-mail"                  
            variant="filled"
            fullWidth={true}
            disabled={!isEditableForm}
            rows={2}
            rowsMax={5}

            defaultValue={email}
            inputRef={register({required: true, pattern: { value: /^\S+@\S+$/i, message: "Wrong email!." } })}
            error={errors.email ? true : false}
            helperText={errors.email ? errors.email.message : null}
          />
        </Grid>

        <Grid item xs={6}>          
          <FormControl 
            variant="filled" 
            fullWidth={true}
            error={errors.profile ? true : false}
            disabled={!isEditableForm}
            >
            <InputLabel id="profile_type-label">Protile type</InputLabel>
            <Controller
              as={
                <Select labelId="profile_type-label">
                  <MenuItem value={'manager'}>Manager</MenuItem>
                  <MenuItem value={'teacher'}>Teacher</MenuItem>
                  <MenuItem value={'student'}>Student</MenuItem>                  
                </Select>
              }
              name="profile_type"
              rules={{ required: "this is required" }}
              control={control}
              defaultValue={profile_type || props.defaultProfile || 'student'}
            />
            <FormHelperText>{errors.profile_type ? errors.profile_type.message : null}</FormHelperText>
            
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Controller
                as={<Switch />}
                type="checkbox"
                control={control}
                name="is_active"                  
                id="is_active"
                variant="filled"
                value={is_active}
                disabled={!isEditableForm}
                rows={2}                
                // color="default"                
                color="primary"
                // defaultValue={is_active || null}
              />          
            }
            label="Enabled"
          />    
        </Grid>

        {/* Show Form action buttons only when Edit action is active */}
        {props.children}
      </Grid>
    </form>
  )
}

export default UserForm;